import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

export default {
  actions: {
    [actions.DO_CREATE_ORDER]({ commit }, payload) {
      return HTTP.post('/orders', payload)
        .then(({ data }) => {
          commit(mutations.SET_ORDER, data.data.orders[0]);
          return data;
        });
    },
    [actions.DO_DELETE_EVENT_ORDERS]({ commit }, payload) {
      const id = payload.id;
      const params = Object.assign({}, payload);
      delete params.id;
      return HTTP.delete(`/events/${id}/orders`)
        .then(({ data }) => {
          commit(mutations.SET_EVENT_ORDERS, []);
          return data;
        });
    },
    [actions.DO_GET_ORDER]({ commit }, payload) {
      const id = payload.id;
      const params = Object.assign({}, payload);
      delete params.id;
      return HTTP.get(`/orders/${id}`, { params })
        .then(({ data }) => {
          commit(mutations.SET_ORDER, data.data.orders[0]);
          return data;
        });
    },
  },
  getters: {
    [getters.GET_ORDER]: state => state.order,
  },
  mutations: {
    [mutations.SET_ORDER](state, order) {
      state.order = order;
    },
    [mutations.SET_EVENT_ORDERS](state, orders) {
      state.orders = orders;
    },
  },
  state: {
    order: {},
    orders: [],
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/orders.js